import { useHTMLProcessor } from "../../@whitespace/gatsby-theme-wordpress/hooks/html-processor";
import decode from "parse-entities";
import parseEntities from "parse-entities";
import React, { useState, useEffect } from 'react';
import { parse } from 'node-html-parser';
import cx from "classnames";
import Button from "./../Button/Button";

import "./Table.scss";

export default function Table({ block, title, head, body, foot, caption, hasFixedLayout }) {
  // Cell content has been removed, we need to get the contents from the complete html
  const { originalContent } = block;

  const [tableData, setTableData] = useState({ head, body, foot });

  const { processContent } = useHTMLProcessor();

  useEffect(() => {
    const root = parse(originalContent);
    const thead = root.querySelector('thead');
    const tbody = root.querySelector('tbody');
    const tfoot = root.querySelector('tfoot');

    const parseRows = (existingRows, rowElements) => {
      return existingRows.map((existingRow, rowIndex) => {
        const cells = rowElements[rowIndex]
          ? rowElements[rowIndex].querySelectorAll('th, td')
          : [];

        return {
          cells: existingRow.cells.map((cell, cellIndex) => ({
            ...cell,
            content: cells[cellIndex] ? cells[cellIndex].innerHTML.trim() : cell.content,
          }))
        };
      });
    };

    const headRows = thead ? thead.querySelectorAll('tr') : [];
    const bodyRows = tbody ? tbody.querySelectorAll('tr') : [];
    const footRows = tfoot ? tfoot.querySelectorAll('tr') : [];

    setTableData({
      head: parseRows(tableData.head, headRows),
      body: parseRows(tableData.body, bodyRows),
      foot: parseRows(tableData.foot, footRows)
    });
  }, [originalContent]); // Empty array ensures this runs only once when component mounts

  const classes = cx(
    "table",
    {"table--layout-default": !hasFixedLayout},
    {"table--layout-fixed": hasFixedLayout},
  );
  return (
    <div className={classes}>
      <table className="table__table">
        {title &&
          <caption className="table__title">{parseEntities(title)}</caption>
        }

        {tableData.head && (
          <thead className="table__head">
            <tr className="table__row">
              {tableData.head?.[0]?.cells?.map((cell, cellIndex) => {
                return <th className="table__cell table__cell--heading" key={`thead-th-${cellIndex}`}>{cell.content}</th>;
              })}
            </tr>
          </thead>
        )}

        {tableData.body && (
          <tbody className="table__body">
            {tableData.body.map((row, rowIndex) => {
              return (
                <tr className="table__row" key={`tbody-${rowIndex}`}>
                  {row.cells.map((cell, cellIndex) => {
                    const processedHTML = processContent(cell.content);
                    let {
                      props: { children },
                    } = processedHTML;
                    let linkHref = children?.[0]?.props?.href;
                    let linkLabel = children?.[0]?.props?.children[0];
                    const newTab = children?.[0]?.props?.target ? true : false;
                    return linkHref ? (
                      <td className="table__cell" key={`tbody-${rowIndex}-td-${cellIndex}`}>
                        <Button
                          icon={false}
                          link={linkHref}
                          linkText={decode(linkLabel)}
                          newTab={newTab}
                        />
                      </td>
                    ) : (
                      <td
                        className="table__cell"
                        key={`tbody-${rowIndex}-td-${cellIndex}`}
                        dangerouslySetInnerHTML={{ __html: cell.content }}
                      />
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        )}

        {tableData.foot && (
          <tfoot className="table__foot">
            <tr className="table__row">
              {tableData.foot?.[0]?.cells?.map((cell, cellIndex) => {
                return (
                  <td
                    className="table__cell"
                    key={`tfoot-td-${cellIndex}`}
                    dangerouslySetInnerHTML={{ __html: cell.content }}
                  />
                );
              })}
            </tr>
          </tfoot>
        )}
      </table>

      {caption &&
        <span className="table__caption mt-s">{caption}</span>
      }
    </div>
  );
}
